import _ScrollTop from '../_app/cuchillo/layout/ScrollTop';

export default class ScrollTop extends _ScrollTop {
  //static show(__call) {}
  //static hide(__call) {}
}
